export default function observer(options) {
	const callback = (entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("observed");
				observer.unobserve(entry.target)
			}
		})
	}

	return new IntersectionObserver(callback, options)
}
